import { p as Hn, c as nr, g as tr, j as Bn } from "./jsx-runtime.js";
import { _ as ut, c as Xe, a as Wn } from "./Transition.js";
import { z as dt, r as ar, m as p, e as ne, F as d, b as P, D as or, h as ft, d as _e, G as pt, H as pe, o as oe, M as Fe, l as ge, W as ie, B as Ye, w as De, i as Yn, L as Ge, J as Gn, V as Zn, T as bt, K as gt, C as Ze, O as Ve, Q as Un, S as Vn, j as Kn, U as Ne, p as ur, A as mt, q as ht, E as vt, t as yt, X as xt } from "./index2.js";
import { b as Xn, V as wt, Q as Ct } from "./index4.js";
import * as we from "react";
import b, { useLayoutEffect as Et, useRef as Ee, useCallback as Ue, createContext as St, useContext as kt, useMemo as ir, useState as Ce, forwardRef as qn, useEffect as Ot } from "react";
import { u as $t } from "./index5.js";
import { N as jt } from "./index6.js";
import { I as Pt } from "./index7.js";
import { J as Lt } from "./index9.js";
import { z as Rt, a as _t, L as zt } from "./index11.js";
import { e as He, K as Qn } from "./index12.js";
import { g as Jn } from "./index10.js";
import { useChatbotContext as Mt } from "./useChatbotContext.js";
var et = {}, Je = { exports: {} }, M = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var dr;
function Tt() {
  if (dr)
    return M;
  dr = 1;
  var e = typeof Symbol == "function" && Symbol.for, n = e ? Symbol.for("react.element") : 60103, r = e ? Symbol.for("react.portal") : 60106, t = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, u = e ? Symbol.for("react.profiler") : 60114, v = e ? Symbol.for("react.provider") : 60109, m = e ? Symbol.for("react.context") : 60110, f = e ? Symbol.for("react.async_mode") : 60111, h = e ? Symbol.for("react.concurrent_mode") : 60111, y = e ? Symbol.for("react.forward_ref") : 60112, w = e ? Symbol.for("react.suspense") : 60113, N = e ? Symbol.for("react.suspense_list") : 60120, _ = e ? Symbol.for("react.memo") : 60115, $ = e ? Symbol.for("react.lazy") : 60116, B = e ? Symbol.for("react.block") : 60121, a = e ? Symbol.for("react.fundamental") : 60117, s = e ? Symbol.for("react.responder") : 60118, c = e ? Symbol.for("react.scope") : 60119;
  function l(i) {
    if (typeof i == "object" && i !== null) {
      var S = i.$$typeof;
      switch (S) {
        case n:
          switch (i = i.type, i) {
            case f:
            case h:
            case t:
            case u:
            case o:
            case w:
              return i;
            default:
              switch (i = i && i.$$typeof, i) {
                case m:
                case y:
                case $:
                case _:
                case v:
                  return i;
                default:
                  return S;
              }
          }
        case r:
          return S;
      }
    }
  }
  function x(i) {
    return l(i) === h;
  }
  return M.AsyncMode = f, M.ConcurrentMode = h, M.ContextConsumer = m, M.ContextProvider = v, M.Element = n, M.ForwardRef = y, M.Fragment = t, M.Lazy = $, M.Memo = _, M.Portal = r, M.Profiler = u, M.StrictMode = o, M.Suspense = w, M.isAsyncMode = function(i) {
    return x(i) || l(i) === f;
  }, M.isConcurrentMode = x, M.isContextConsumer = function(i) {
    return l(i) === m;
  }, M.isContextProvider = function(i) {
    return l(i) === v;
  }, M.isElement = function(i) {
    return typeof i == "object" && i !== null && i.$$typeof === n;
  }, M.isForwardRef = function(i) {
    return l(i) === y;
  }, M.isFragment = function(i) {
    return l(i) === t;
  }, M.isLazy = function(i) {
    return l(i) === $;
  }, M.isMemo = function(i) {
    return l(i) === _;
  }, M.isPortal = function(i) {
    return l(i) === r;
  }, M.isProfiler = function(i) {
    return l(i) === u;
  }, M.isStrictMode = function(i) {
    return l(i) === o;
  }, M.isSuspense = function(i) {
    return l(i) === w;
  }, M.isValidElementType = function(i) {
    return typeof i == "string" || typeof i == "function" || i === t || i === h || i === u || i === o || i === w || i === N || typeof i == "object" && i !== null && (i.$$typeof === $ || i.$$typeof === _ || i.$$typeof === v || i.$$typeof === m || i.$$typeof === y || i.$$typeof === a || i.$$typeof === s || i.$$typeof === c || i.$$typeof === B);
  }, M.typeOf = l, M;
}
var T = {}, fr;
function Nt() {
  return fr || (fr = 1, Hn.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, n = e ? Symbol.for("react.element") : 60103, r = e ? Symbol.for("react.portal") : 60106, t = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, u = e ? Symbol.for("react.profiler") : 60114, v = e ? Symbol.for("react.provider") : 60109, m = e ? Symbol.for("react.context") : 60110, f = e ? Symbol.for("react.async_mode") : 60111, h = e ? Symbol.for("react.concurrent_mode") : 60111, y = e ? Symbol.for("react.forward_ref") : 60112, w = e ? Symbol.for("react.suspense") : 60113, N = e ? Symbol.for("react.suspense_list") : 60120, _ = e ? Symbol.for("react.memo") : 60115, $ = e ? Symbol.for("react.lazy") : 60116, B = e ? Symbol.for("react.block") : 60121, a = e ? Symbol.for("react.fundamental") : 60117, s = e ? Symbol.for("react.responder") : 60118, c = e ? Symbol.for("react.scope") : 60119;
    function l(g) {
      return typeof g == "string" || typeof g == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      g === t || g === h || g === u || g === o || g === w || g === N || typeof g == "object" && g !== null && (g.$$typeof === $ || g.$$typeof === _ || g.$$typeof === v || g.$$typeof === m || g.$$typeof === y || g.$$typeof === a || g.$$typeof === s || g.$$typeof === c || g.$$typeof === B);
    }
    function x(g) {
      if (typeof g == "object" && g !== null) {
        var z = g.$$typeof;
        switch (z) {
          case n:
            var F = g.type;
            switch (F) {
              case f:
              case h:
              case t:
              case u:
              case o:
              case w:
                return F;
              default:
                var K = F && F.$$typeof;
                switch (K) {
                  case m:
                  case y:
                  case $:
                  case _:
                  case v:
                    return K;
                  default:
                    return z;
                }
            }
          case r:
            return z;
        }
      }
    }
    var i = f, S = h, L = m, j = v, E = n, A = y, H = t, J = $, U = _, V = r, ee = u, R = o, q = w, Y = !1;
    function I(g) {
      return Y || (Y = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), W(g) || x(g) === f;
    }
    function W(g) {
      return x(g) === h;
    }
    function Se(g) {
      return x(g) === m;
    }
    function he(g) {
      return x(g) === v;
    }
    function se(g) {
      return typeof g == "object" && g !== null && g.$$typeof === n;
    }
    function Le(g) {
      return x(g) === y;
    }
    function ke(g) {
      return x(g) === t;
    }
    function ve(g) {
      return x(g) === $;
    }
    function te(g) {
      return x(g) === _;
    }
    function ye(g) {
      return x(g) === r;
    }
    function Oe(g) {
      return x(g) === u;
    }
    function $e(g) {
      return x(g) === o;
    }
    function ue(g) {
      return x(g) === w;
    }
    T.AsyncMode = i, T.ConcurrentMode = S, T.ContextConsumer = L, T.ContextProvider = j, T.Element = E, T.ForwardRef = A, T.Fragment = H, T.Lazy = J, T.Memo = U, T.Portal = V, T.Profiler = ee, T.StrictMode = R, T.Suspense = q, T.isAsyncMode = I, T.isConcurrentMode = W, T.isContextConsumer = Se, T.isContextProvider = he, T.isElement = se, T.isForwardRef = Le, T.isFragment = ke, T.isLazy = ve, T.isMemo = te, T.isPortal = ye, T.isProfiler = Oe, T.isStrictMode = $e, T.isSuspense = ue, T.isValidElementType = l, T.typeOf = x;
  }()), T;
}
Hn.env.NODE_ENV === "production" ? Je.exports = Tt() : Je.exports = Nt();
var At = Je.exports;
Object.defineProperty(et, "__esModule", { value: !0 });
var qe = b, Dt = At;
function rt(e, n, r) {
  return n === void 0 && (n = 0), r === void 0 && (r = []), qe.Children.toArray(e).reduce(function(t, o, u) {
    return Dt.isFragment(o) ? t.push.apply(t, rt(o.props.children, n + 1, r.concat(o.key || u))) : qe.isValidElement(o) ? t.push(qe.cloneElement(o, {
      key: r.concat(String(o.key)).join(".")
    })) : (typeof o == "string" || typeof o == "number") && t.push(o), t;
  }, []);
}
var It = et.default = rt, Ft = Et, Ht = function(n) {
  var r = we.useRef(n);
  return Ft(function() {
    r.current = n;
  }), r;
}, pr = function(n, r) {
  if (typeof n == "function") {
    n(r);
    return;
  }
  n.current = r;
}, Bt = function(n, r) {
  var t = Ee();
  return Ue(function(o) {
    n.current = o, t.current && pr(t.current, null), t.current = r, r && pr(r, o);
  }, [r]);
}, br = {
  "min-height": "0",
  "max-height": "none",
  height: "0",
  visibility: "hidden",
  overflow: "hidden",
  position: "absolute",
  "z-index": "-1000",
  top: "0",
  right: "0"
}, Wt = function(n) {
  Object.keys(br).forEach(function(r) {
    n.style.setProperty(r, br[r], "important");
  });
}, gr = Wt, re = null, mr = function(n, r) {
  var t = n.scrollHeight;
  return r.sizingStyle.boxSizing === "border-box" ? t + r.borderSize : t - r.paddingSize;
};
function Yt(e, n, r, t) {
  r === void 0 && (r = 1), t === void 0 && (t = 1 / 0), re || (re = document.createElement("textarea"), re.setAttribute("tabindex", "-1"), re.setAttribute("aria-hidden", "true"), gr(re)), re.parentNode === null && document.body.appendChild(re);
  var o = e.paddingSize, u = e.borderSize, v = e.sizingStyle, m = v.boxSizing;
  Object.keys(v).forEach(function(N) {
    var _ = N;
    re.style[_] = v[_];
  }), gr(re), re.value = n;
  var f = mr(re, e);
  re.value = n, f = mr(re, e), re.value = "x";
  var h = re.scrollHeight - o, y = h * r;
  m === "border-box" && (y = y + o + u), f = Math.max(y, f);
  var w = h * t;
  return m === "border-box" && (w = w + o + u), f = Math.min(w, f), [f, h];
}
var hr = function() {
}, Gt = function(n, r) {
  return n.reduce(function(t, o) {
    return t[o] = r[o], t;
  }, {});
}, Zt = [
  "borderBottomWidth",
  "borderLeftWidth",
  "borderRightWidth",
  "borderTopWidth",
  "boxSizing",
  "fontFamily",
  "fontSize",
  "fontStyle",
  "fontWeight",
  "letterSpacing",
  "lineHeight",
  "paddingBottom",
  "paddingLeft",
  "paddingRight",
  "paddingTop",
  // non-standard
  "tabSize",
  "textIndent",
  // non-standard
  "textRendering",
  "textTransform",
  "width",
  "wordBreak"
], Ut = !!document.documentElement.currentStyle, Vt = function(n) {
  var r = window.getComputedStyle(n);
  if (r === null)
    return null;
  var t = Gt(Zt, r), o = t.boxSizing;
  if (o === "")
    return null;
  Ut && o === "border-box" && (t.width = parseFloat(t.width) + parseFloat(t.borderRightWidth) + parseFloat(t.borderLeftWidth) + parseFloat(t.paddingRight) + parseFloat(t.paddingLeft) + "px");
  var u = parseFloat(t.paddingBottom) + parseFloat(t.paddingTop), v = parseFloat(t.borderBottomWidth) + parseFloat(t.borderTopWidth);
  return {
    sizingStyle: t,
    paddingSize: u,
    borderSize: v
  };
}, Kt = Vt;
function nt(e, n, r) {
  var t = Ht(r);
  we.useLayoutEffect(function() {
    var o = function(v) {
      return t.current(v);
    };
    if (e)
      return e.addEventListener(n, o), function() {
        return e.removeEventListener(n, o);
      };
  }, []);
}
var Xt = function(n) {
  nt(window, "resize", n);
}, qt = function(n) {
  nt(document.fonts, "loadingdone", n);
}, Qt = ["cacheMeasurements", "maxRows", "minRows", "onChange", "onHeightChange"], Jt = function(n, r) {
  var t = n.cacheMeasurements, o = n.maxRows, u = n.minRows, v = n.onChange, m = v === void 0 ? hr : v, f = n.onHeightChange, h = f === void 0 ? hr : f, y = ut(n, Qt), w = y.value !== void 0, N = we.useRef(null), _ = Bt(N, r), $ = we.useRef(0), B = we.useRef(), a = function() {
    var l = N.current, x = t && B.current ? B.current : Kt(l);
    if (x) {
      B.current = x;
      var i = Yt(x, l.value || l.placeholder || "x", u, o), S = i[0], L = i[1];
      $.current !== S && ($.current = S, l.style.setProperty("height", S + "px", "important"), h(S, {
        rowHeight: L
      }));
    }
  }, s = function(l) {
    w || a(), m(l);
  };
  return we.useLayoutEffect(a), Xt(a), qt(a), /* @__PURE__ */ we.createElement("textarea", dt({}, y, {
    onChange: s,
    ref: _
  }));
}, ea = /* @__PURE__ */ we.forwardRef(Jt), tt = { exports: {} };
(function(e, n) {
  (function(r, t) {
    e.exports = t(b, ar);
  })(nr, function(r, t) {
    function o(a) {
      if (a && typeof a == "object" && "default" in a)
        return a;
      var s = /* @__PURE__ */ Object.create(null);
      return a && Object.keys(a).forEach(function(c) {
        if (c !== "default") {
          var l = Object.getOwnPropertyDescriptor(a, c);
          Object.defineProperty(s, c, l.get ? l : { enumerable: !0, get: function() {
            return a[c];
          } });
        }
      }), s.default = a, Object.freeze(s);
    }
    var u = o(r);
    function v(a) {
      var s = function(c, l) {
        if (typeof c != "object" || !c)
          return c;
        var x = c[Symbol.toPrimitive];
        if (x !== void 0) {
          var i = x.call(c, l);
          if (typeof i != "object")
            return i;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return String(c);
      }(a, "string");
      return typeof s == "symbol" ? s : s + "";
    }
    function m(a, s, c) {
      return (s = v(s)) in a ? Object.defineProperty(a, s, { value: c, enumerable: !0, configurable: !0, writable: !0 }) : a[s] = c, a;
    }
    function f() {
      return f = Object.assign ? Object.assign.bind() : function(a) {
        for (var s = 1; s < arguments.length; s++) {
          var c = arguments[s];
          for (var l in c)
            Object.prototype.hasOwnProperty.call(c, l) && (a[l] = c[l]);
        }
        return a;
      }, f.apply(this, arguments);
    }
    function h(a, s) {
      if (a == null)
        return {};
      var c, l, x = function(S, L) {
        if (S == null)
          return {};
        var j, E, A = {}, H = Object.keys(S);
        for (E = 0; E < H.length; E++)
          j = H[E], L.indexOf(j) >= 0 || (A[j] = S[j]);
        return A;
      }(a, s);
      if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(a);
        for (l = 0; l < i.length; l++)
          c = i[l], s.indexOf(c) >= 0 || Object.prototype.propertyIsEnumerable.call(a, c) && (x[c] = a[c]);
      }
      return x;
    }
    function y(a, s) {
      return s || (s = a.slice(0)), Object.freeze(Object.defineProperties(a, { raw: { value: Object.freeze(s) } }));
    }
    var w, N, _ = { small: 14, default: 16, large: 20, xlarge: 24 }, $ = ["className", "size", "title", "aria-label", "aria-labelledby", "fill", "role"], B = function(a) {
      var s = a.className, c = a.size, l = c === void 0 ? 16 : c, x = a.title, i = a["aria-label"], S = a["aria-labelledby"], L = a.fill, j = a.role, E = j === void 0 ? "img" : j, A = h(a, $), H = t.css(w || (w = y([`
        color: `, `;
      `])), L), J = t.css(N || (N = y([`
        flex-shrink: 0;
      `]))), U = function(V, ee, R) {
        var q, Y = R["aria-label"], I = R["aria-labelledby"], W = R.title;
        switch (V) {
          case "img":
            return Y || I || W ? m(m(m({}, "aria-labelledby", I), "aria-label", Y), "title", W) : { "aria-label": (q = ee, "".concat(q.replace(/([a-z])([A-Z])/g, "$1 $2"), " Icon")) };
          case "presentation":
            return { "aria-hidden": !0, alt: "" };
        }
      }(E, "MagnifyingGlass", m(m({ title: x }, "aria-label", i), "aria-labelledby", S));
      return u.createElement("svg", f({ className: t.cx(m({}, H, L != null), J, s), height: typeof l == "number" ? l : _[l], width: typeof l == "number" ? l : _[l], role: E }, U, A, { viewBox: "0 0 16 16" }), u.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.3234 9.81874C4.07618 11.5715 6.75062 11.8398 8.78588 10.6244L12.93 14.7685C13.4377 15.2762 14.2608 15.2762 14.7685 14.7685C15.2762 14.2608 15.2762 13.4377 14.7685 12.93L10.6244 8.78588C11.8398 6.75062 11.5715 4.07619 9.81873 2.32341C7.74896 0.253628 4.39318 0.253628 2.3234 2.32341C0.253624 4.39319 0.253624 7.74896 2.3234 9.81874ZM7.98026 4.16188C9.03467 5.2163 9.03467 6.92585 7.98026 7.98026C6.92584 9.03468 5.2163 9.03468 4.16188 7.98026C3.10746 6.92585 3.10746 5.2163 4.16188 4.16188C5.2163 3.10747 6.92584 3.10747 7.98026 4.16188Z", fill: "currentColor" }));
    };
    return B.displayName = "MagnifyingGlass", B.isGlyph = !0, B;
  });
})(tt);
var ra = tt.exports;
const na = /* @__PURE__ */ tr(ra);
var at = { exports: {} };
(function(e, n) {
  (function(r, t) {
    e.exports = t(b, ar);
  })(nr, function(r, t) {
    function o(a) {
      if (a && typeof a == "object" && "default" in a)
        return a;
      var s = /* @__PURE__ */ Object.create(null);
      return a && Object.keys(a).forEach(function(c) {
        if (c !== "default") {
          var l = Object.getOwnPropertyDescriptor(a, c);
          Object.defineProperty(s, c, l.get ? l : { enumerable: !0, get: function() {
            return a[c];
          } });
        }
      }), s.default = a, Object.freeze(s);
    }
    var u = o(r);
    function v(a) {
      var s = function(c, l) {
        if (typeof c != "object" || !c)
          return c;
        var x = c[Symbol.toPrimitive];
        if (x !== void 0) {
          var i = x.call(c, l);
          if (typeof i != "object")
            return i;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return String(c);
      }(a, "string");
      return typeof s == "symbol" ? s : s + "";
    }
    function m(a, s, c) {
      return (s = v(s)) in a ? Object.defineProperty(a, s, { value: c, enumerable: !0, configurable: !0, writable: !0 }) : a[s] = c, a;
    }
    function f() {
      return f = Object.assign ? Object.assign.bind() : function(a) {
        for (var s = 1; s < arguments.length; s++) {
          var c = arguments[s];
          for (var l in c)
            Object.prototype.hasOwnProperty.call(c, l) && (a[l] = c[l]);
        }
        return a;
      }, f.apply(this, arguments);
    }
    function h(a, s) {
      if (a == null)
        return {};
      var c, l, x = function(S, L) {
        if (S == null)
          return {};
        var j, E, A = {}, H = Object.keys(S);
        for (E = 0; E < H.length; E++)
          j = H[E], L.indexOf(j) >= 0 || (A[j] = S[j]);
        return A;
      }(a, s);
      if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(a);
        for (l = 0; l < i.length; l++)
          c = i[l], s.indexOf(c) >= 0 || Object.prototype.propertyIsEnumerable.call(a, c) && (x[c] = a[c]);
      }
      return x;
    }
    function y(a, s) {
      return s || (s = a.slice(0)), Object.freeze(Object.defineProperties(a, { raw: { value: Object.freeze(s) } }));
    }
    var w, N, _ = { small: 14, default: 16, large: 20, xlarge: 24 }, $ = ["className", "size", "title", "aria-label", "aria-labelledby", "fill", "role"], B = function(a) {
      var s = a.className, c = a.size, l = c === void 0 ? 16 : c, x = a.title, i = a["aria-label"], S = a["aria-labelledby"], L = a.fill, j = a.role, E = j === void 0 ? "img" : j, A = h(a, $), H = t.css(w || (w = y([`
        color: `, `;
      `])), L), J = t.css(N || (N = y([`
        flex-shrink: 0;
      `]))), U = function(V, ee, R) {
        var q, Y = R["aria-label"], I = R["aria-labelledby"], W = R.title;
        switch (V) {
          case "img":
            return Y || I || W ? m(m(m({}, "aria-labelledby", I), "aria-label", Y), "title", W) : { "aria-label": (q = ee, "".concat(q.replace(/([a-z])([A-Z])/g, "$1 $2"), " Icon")) };
          case "presentation":
            return { "aria-hidden": !0, alt: "" };
        }
      }(E, "XWithCircle", m(m({ title: x }, "aria-label", i), "aria-labelledby", S));
      return u.createElement("svg", f({ className: t.cx(m({}, H, L != null), J, s), height: typeof l == "number" ? l : _[l], width: typeof l == "number" ? l : _[l], role: E }, U, A, { viewBox: "0 0 16 16" }), u.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15ZM9.41421 5.17157C9.80474 4.78105 10.4379 4.78105 10.8284 5.17157C11.219 5.5621 11.219 6.19526 10.8284 6.58579L9.41421 8L10.8284 9.41421C11.219 9.80474 11.219 10.4379 10.8284 10.8284C10.4379 11.219 9.80474 11.219 9.41421 10.8284L8 9.41421L6.58579 10.8284C6.19526 11.219 5.5621 11.219 5.17157 10.8284C4.78105 10.4379 4.78105 9.80474 5.17157 9.41421L6.58579 8L5.17157 6.58579C4.78105 6.19526 4.78105 5.5621 5.17157 5.17157C5.5621 4.78105 6.19526 4.78105 6.58579 5.17157L8 6.58579L9.41421 5.17157Z", fill: "currentColor" }));
    };
    return B.displayName = "XWithCircle", B.isGlyph = !0, B;
  });
})(at);
var ta = at.exports;
const aa = /* @__PURE__ */ tr(ta);
var ot = { exports: {} };
(function(e, n) {
  (function(r, t) {
    e.exports = t(b, ar);
  })(nr, function(r, t) {
    function o(a) {
      if (a && typeof a == "object" && "default" in a)
        return a;
      var s = /* @__PURE__ */ Object.create(null);
      return a && Object.keys(a).forEach(function(c) {
        if (c !== "default") {
          var l = Object.getOwnPropertyDescriptor(a, c);
          Object.defineProperty(s, c, l.get ? l : { enumerable: !0, get: function() {
            return a[c];
          } });
        }
      }), s.default = a, Object.freeze(s);
    }
    var u = o(r);
    function v(a) {
      var s = function(c, l) {
        if (typeof c != "object" || !c)
          return c;
        var x = c[Symbol.toPrimitive];
        if (x !== void 0) {
          var i = x.call(c, l);
          if (typeof i != "object")
            return i;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return String(c);
      }(a, "string");
      return typeof s == "symbol" ? s : s + "";
    }
    function m(a, s, c) {
      return (s = v(s)) in a ? Object.defineProperty(a, s, { value: c, enumerable: !0, configurable: !0, writable: !0 }) : a[s] = c, a;
    }
    function f() {
      return f = Object.assign ? Object.assign.bind() : function(a) {
        for (var s = 1; s < arguments.length; s++) {
          var c = arguments[s];
          for (var l in c)
            Object.prototype.hasOwnProperty.call(c, l) && (a[l] = c[l]);
        }
        return a;
      }, f.apply(this, arguments);
    }
    function h(a, s) {
      if (a == null)
        return {};
      var c, l, x = function(S, L) {
        if (S == null)
          return {};
        var j, E, A = {}, H = Object.keys(S);
        for (E = 0; E < H.length; E++)
          j = H[E], L.indexOf(j) >= 0 || (A[j] = S[j]);
        return A;
      }(a, s);
      if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(a);
        for (l = 0; l < i.length; l++)
          c = i[l], s.indexOf(c) >= 0 || Object.prototype.propertyIsEnumerable.call(a, c) && (x[c] = a[c]);
      }
      return x;
    }
    function y(a, s) {
      return s || (s = a.slice(0)), Object.freeze(Object.defineProperties(a, { raw: { value: Object.freeze(s) } }));
    }
    var w, N, _ = { small: 14, default: 16, large: 20, xlarge: 24 }, $ = ["className", "size", "title", "aria-label", "aria-labelledby", "fill", "role"], B = function(a) {
      var s = a.className, c = a.size, l = c === void 0 ? 16 : c, x = a.title, i = a["aria-label"], S = a["aria-labelledby"], L = a.fill, j = a.role, E = j === void 0 ? "img" : j, A = h(a, $), H = t.css(w || (w = y([`
        color: `, `;
      `])), L), J = t.css(N || (N = y([`
        flex-shrink: 0;
      `]))), U = function(V, ee, R) {
        var q, Y = R["aria-label"], I = R["aria-labelledby"], W = R.title;
        switch (V) {
          case "img":
            return Y || I || W ? m(m(m({}, "aria-labelledby", I), "aria-label", Y), "title", W) : { "aria-label": (q = ee, "".concat(q.replace(/([a-z])([A-Z])/g, "$1 $2"), " Icon")) };
          case "presentation":
            return { "aria-hidden": !0, alt: "" };
        }
      }(E, "Refresh", m(m({ title: x }, "aria-label", i), "aria-labelledby", S));
      return u.createElement("svg", f({ className: t.cx(m({}, H, L != null), J, s), height: typeof l == "number" ? l : _[l], width: typeof l == "number" ? l : _[l], role: E }, U, A, { viewBox: "0 0 16 16" }), u.createElement("path", { d: "M8.03289 2C10.7318 2 12.9831 3.71776 13.5 6L14.9144 6C15.4555 6 15.7061 6.67202 15.297 7.02629L12.8153 9.17546C12.5957 9.36566 12.2697 9.36566 12.0501 9.17545L9.56844 7.02629C9.15937 6.67202 9.40991 6 9.95107 6H11.3977C10.929 4.91456 9.7172 4 8.03289 4C7.00662 4 6.15578 4.33954 5.54157 4.85039C5.29859 5.05248 4.92429 5.0527 4.72549 4.80702L4.11499 4.05254C3.95543 3.85535 3.96725 3.56792 4.1591 3.40197C5.16255 2.53394 6.52815 2 8.03289 2Z", fill: "currentColor" }), u.createElement("path", { d: "M3.94991 6.84265C3.73028 6.65245 3.40429 6.65245 3.18466 6.84265L0.703017 8.99182C0.293944 9.34608 0.544489 10.0181 1.08564 10.0181H2.50411C3.02878 12.2913 5.27531 14 7.96711 14C9.47186 14 10.8375 13.4661 11.8409 12.598C12.0327 12.4321 12.0446 12.1447 11.885 11.9475L11.2745 11.193C11.0757 10.9473 10.7014 10.9475 10.4584 11.1496C9.84422 11.6605 8.99338 12 7.96711 12C6.29218 12 5.08453 11.0956 4.6102 10.0181H6.04893C6.59009 10.0181 6.84063 9.34608 6.43156 8.99182L3.94991 6.84265Z", fill: "currentColor" }));
    };
    return B.displayName = "Refresh", B.isGlyph = !0, B;
  });
})(ot);
var oa = ot.exports;
const ia = /* @__PURE__ */ tr(oa);
function vr(e, n) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(e);
    n && (t = t.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), r.push.apply(r, t);
  }
  return r;
}
function Be(e) {
  for (var n = 1; n < arguments.length; n++) {
    var r = arguments[n] != null ? arguments[n] : {};
    n % 2 ? vr(Object(r), !0).forEach(function(t) {
      O(e, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : vr(Object(r)).forEach(function(t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return e;
}
function la(e) {
  var n = function(r, t) {
    if (typeof r != "object" || !r)
      return r;
    var o = r[Symbol.toPrimitive];
    if (o !== void 0) {
      var u = o.call(r, t);
      if (typeof u != "object")
        return u;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return String(r);
  }(e, "string");
  return typeof n == "symbol" ? n : n + "";
}
function O(e, n, r) {
  return (n = la(n)) in e ? Object.defineProperty(e, n, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[n] = r, e;
}
function Ie() {
  return Ie = Object.assign ? Object.assign.bind() : function(e) {
    for (var n = 1; n < arguments.length; n++) {
      var r = arguments[n];
      for (var t in r)
        Object.prototype.hasOwnProperty.call(r, t) && (e[t] = r[t]);
    }
    return e;
  }, Ie.apply(this, arguments);
}
function Ke(e, n) {
  if (e == null)
    return {};
  var r, t, o = function(v, m) {
    if (v == null)
      return {};
    var f, h, y = {}, w = Object.keys(v);
    for (h = 0; h < w.length; h++)
      f = w[h], m.indexOf(f) >= 0 || (y[f] = v[f]);
    return y;
  }(e, n);
  if (Object.getOwnPropertySymbols) {
    var u = Object.getOwnPropertySymbols(e);
    for (t = 0; t < u.length; t++)
      r = u[t], n.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (o[r] = e[r]);
  }
  return o;
}
function C(e, n) {
  return n || (n = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(n) } }));
}
function Qe(e, n) {
  return function(r) {
    if (Array.isArray(r))
      return r;
  }(e) || function(r, t) {
    var o = r == null ? null : typeof Symbol < "u" && r[Symbol.iterator] || r["@@iterator"];
    if (o != null) {
      var u, v, m, f, h = [], y = !0, w = !1;
      try {
        if (m = (o = o.call(r)).next, t !== 0)
          for (; !(y = (u = m.call(o)).done) && (h.push(u.value), h.length !== t); y = !0)
            ;
      } catch (N) {
        w = !0, v = N;
      } finally {
        try {
          if (!y && o.return != null && (f = o.return(), Object(f) !== f))
            return;
        } finally {
          if (w)
            throw v;
        }
      }
      return h;
    }
  }(e, n) || function(r, t) {
    if (r) {
      if (typeof r == "string")
        return yr(r, t);
      var o = Object.prototype.toString.call(r).slice(8, -1);
      if (o === "Object" && r.constructor && (o = r.constructor.name), o === "Map" || o === "Set")
        return Array.from(r);
      if (o === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(o))
        return yr(r, t);
    }
  }(e, n) || function() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }();
}
function yr(e, n) {
  n > e.length && (n = e.length);
  for (var r = 0, t = new Array(n); r < n; r++)
    t[r] = e[r];
  return t;
}
var xr, wr, Cr, ca = ["children"], it = St({});
function sa(e) {
  var n = e.children, r = Ke(e, ca);
  return b.createElement(it.Provider, { value: r }, n);
}
var Er, Sr, kr, Or, $r, jr, Pr, Lr, Rr, _r, zr, Mr, Tr, Nr, Ar, Dr, Ir, Fr, Hr, Br, Wr, Yr, Gr, Zr, Ur, Vr, Kr, Xr, qr, Qr, Jr, en, rn, nn, tn, an, on, ua = p(xr || (xr = C([`
  display: flex;
  align-items: center;
  gap: `, `px;
  font-style: italic;
  font-weight: 300;
  padding-block: `, `px;
`])), ne[2], ne[1]), da = O(O({}, P.Light, p(wr || (wr = C([`
    color: `, `;
  `])), d.gray.dark1)), P.Dark, p(Cr || (Cr = C([`
    color: `, `;
  `])), d.gray.light1)), fa = function() {
  var e = _e().theme;
  return b.createElement(He, { "aria-label": "No results found", isInteractive: !1, className: oe(ua, da[e]) }, b.createElement("span", null, "No results found"));
}, pa = p(Er || (Er = C([`
  display: flex;
  align-items: center;
  gap: `, `px;
  padding-block: `, `px;
`])), ne[2], ne[1]), ba = or(Sr || (Sr = C([`
  from {
    transform: rotate(0deg);
  } 
  to {
    transform: rotate(360deg);
  }
`]))), ga = p(kr || (kr = C([`
  height: 16px;
  width: 16px;
  animation: `, ` 1.5s linear infinite;
`])), ba), ma = function() {
  var e = _e().darkMode;
  return b.createElement(He, { "data-testid": "lg-search-input-loading-option", "aria-label": "Loading results", isInteractive: !1, className: pa }, b.createElement(ia, { color: e ? d.blue.light1 : d.blue.base, className: ga }), b.createElement("span", null, "Loading results"));
}, ha = p(Or || (Or = C([`
  box-shadow: 0px 4px 7px `, `;
  padding: 12px 0;
  border-radius: 12px;
`])), ft(0.75, "#000000")), va = function(e) {
  return p($r || ($r = C([`
  background-color: `, `;
  border: 1px solid `, `;
`])), ur[e].background.primary.default, ur[e].border.secondary.default);
}, ya = p(jr || (jr = C([`
  padding: 0;
  margin: 0;
  border-radius: inherit;
  overflow-y: auto;
  scroll-behavior: smooth;
`]))), xa = ["children", "open", "refEl", "footerSlot"], lr = b.forwardRef(function(e, n) {
  var r = e.children, t = e.open, o = t !== void 0 && t, u = e.refEl, v = e.footerSlot, m = Ke(e, xa), f = _e().theme, h = kt(it).state, y = ir(function() {
    var _, $;
    return (_ = ($ = u.current) === null || $ === void 0 ? void 0 : $.clientWidth) !== null && _ !== void 0 ? _ : 0;
  }, [u, o]), w = pt(u), N = pe(w) ? "unset" : "".concat(Math.min(w, 256), "px");
  return b.createElement(Rt, { "data-testid": "lg-search-input-popover", spacing: ne[200], active: o, align: "bottom", justify: "start", className: oe(ha, va(f), p(Pr || (Pr = C([`
            width: `, `px;
            min-width: `, `px;
          `])), y, y)), refEl: u, dismissMode: _t.Manual, renderMode: zt.TopLayer }, h === "loading" ? b.createElement(ma, null) : b.createElement(b.Fragment, null, b.createElement("ul", Ie({ role: "listbox", "aria-live": "polite", "aria-relevant": "additions removals", "aria-expanded": o, ref: n, className: oe(ya, p(Lr || (Lr = C([`
                  max-height: `, `;
                `])), N)) }, m), b.Children.count(r) ? r : b.createElement(fa, null)), v));
});
lr.displayName = "SearchResultsMenu";
var xe = function(e) {
  return "0 0 0 100px ".concat(e, " inset");
}, wa = p(Rr || (Rr = C([`
  outline: none;
`]))), Ca = p(_r || (_r = C([`
  position: relative;
  display: grid;
  grid-auto-flow: column;
  align-items: center;
  justify-items: center;
  border: 1px solid;
  border-radius: 6px;
  z-index: 0;
  transition: `, `ms ease-in-out;
  transition-property: border-color, box-shadow;
`])), Fe.default), Ea = O(O(O(O({}, ie.XSmall, p(zr || (zr = C([`
    font-size: `, `px;
    line-height: `, `px;
    height: 22px;
    grid-template-columns: 28px 1fr 36px;
  `])), ge.body1.fontSize, ge.body1.lineHeight)), ie.Small, p(Mr || (Mr = C([`
    font-size: `, `px;
    line-height: `, `px;
    height: 28px;
    grid-template-columns: 32px 1fr 36px;
  `])), ge.body1.fontSize, ge.body1.lineHeight)), ie.Default, p(Tr || (Tr = C([`
    font-size: `, `px;
    line-height: `, `px;
    height: 36px;
    grid-template-columns: 36px 1fr 36px;
  `])), ge.body1.fontSize, ge.body1.lineHeight)), ie.Large, p(Nr || (Nr = C([`
    font-size: `, `px;
    line-height: `, `px;
    height: 48px;
    grid-template-columns: 36px 1fr 44px;
  `])), ge.large.fontSize, ge.large.lineHeight)), Sa = O(O({}, P.Light, p(Ar || (Ar = C([`
    color: `, `;
    background: `, `;
    border-color: `, `;
  `])), d.black, d.white, d.gray.base)), P.Dark, p(Dr || (Dr = C([`
    color: `, `;
    background-color: `, `;
    border-color: `, `;
  `])), d.gray.light2, d.gray.dark4, d.gray.base)), ka = O(O({}, P.Light, p(Ir || (Ir = C([`
    &:hover,
    &:active {
      &:not(:disabled):not(:focus-within) {
        box-shadow: `, `;
      }
    }
  `])), Ye.light.gray)), P.Dark, p(Fr || (Fr = C([`
    &:hover,
    &:active {
      &:not(:disabled):not(:focus-within) {
        box-shadow: `, `;
      }
    }
  `])), Ye.dark.gray)), Oa = O(O({}, P.Light, p(Hr || (Hr = C([`
    &:not(:disabled):focus-within {
      box-shadow: `, `;
      border-color: `, `;
    }
  `])), De.light.input, d.white)), P.Dark, p(Br || (Br = C([`
    &:not(:disabled):focus-within {
      box-shadow: `, `;
      border-color: `, `;
    }
  `])), De.dark.input, d.gray.dark4)), $a = O(O({}, P.Light, p(Wr || (Wr = C([`
    cursor: not-allowed;
    color: `, `;
    background-color: `, `;
    border-color: `, `;
  `])), d.gray.base, d.gray.light2, d.gray.light1)), P.Dark, p(Yr || (Yr = C([`
    cursor: not-allowed;
    color: `, `;
    background-color: `, `;
    border-color: `, `;
  `])), d.gray.dark2, d.gray.dark3, d.gray.dark2)), ja = p(Gr || (Gr = C([`
  font-size: inherit;
  line-height: inherit;
  color: inherit;
  background-color: inherit;
  font-family: `, `;
  width: 100%;
  height: 1.5em;
  font-weight: `, `;
  z-index: 1;
  outline: none;
  border: none;
  padding: 0;

  &[aria-disabled='true'] {
    cursor: not-allowed;

    &:hover,
    &:active {
      box-shadow: none;
    }
  }

  &::placeholder {
    font-size: inherit;
    line-height: inherit;
  }
  &::-ms-clear,
  &::-ms-reveal {
    display: none;
    width: 0;
    height: 0;
  }
  &::-webkit-search-decoration,
  &::-webkit-search-cancel-button,
  &::-webkit-search-results-button,
  &::-webkit-search-results-decoration {
    display: none;
  }
`])), Yn.default, Ge.regular), Pa = O(O({}, P.Light, p(Zr || (Zr = C([`
    &:-webkit-autofill {
      color: inherit;
      background: transparent;
      border: none;
      -webkit-text-fill-color: inherit;

      &[aria-disabled='false'] {
        box-shadow: `, `;

        &:focus {
          box-shadow: `, `,
            `, `;
        }

        &:hover:not(:focus) {
          box-shadow: `, `,
            `, `;
        }
      }
    }

    &::placeholder {
      color: `, `;
      font-weight: `, `;
    }

    &[aria-disabled='true'] {
      &::placeholder {
        color: `, `;
      }

      &:-webkit-autofill {
        &,
        &:hover,
        &:focus {
          appearance: none;
          border: 1px solid `, `;
          -webkit-text-fill-color: `, `;
          box-shadow: `, `;
        }
      }
    }
  `])), xe(d.white), xe(d.white), De.light.input, xe(d.white), Ye.light.gray, d.gray.base, Ge.regular, d.gray.base, d.gray.base, d.gray.base, xe(d.gray.light2))), P.Dark, p(Ur || (Ur = C([`
    &:-webkit-autofill {
      color: inherit;
      background: transparent;
      border: none;
      -webkit-text-fill-color: `, `;
      &[aria-disabled='false'] {
        box-shadow: `, `;

        &:focus {
          box-shadow: `, `,
            `, `;
          border-color: `, `;
        }

        &:hover:not(:focus) {
          box-shadow: `, `,
            `, `;
        }
      }
    }

    &::placeholder {
      color: `, `;
      font-weight: `, `;
    }

    &[aria-disabled='true'] {
      &::placeholder {
        color: `, `;
      }

      &:-webkit-autofill {
        &,
        &:hover,
        &:focus {
          appearance: none;
          border: 1px solid `, `;
          -webkit-text-fill-color: `, `;
          box-shadow: `, `;
        }
      }
    }
  `])), d.gray.light3, xe(d.gray.dark4), xe(d.gray.dark4), De.dark.input, d.blue.light1, xe(d.gray.dark4), Ye.dark.gray, d.gray.dark1, Ge.regular, d.gray.dark1, d.gray.dark1, d.gray.dark1, xe(d.gray.dark2))), La = O(O({}, P.Light, p(Vr || (Vr = C([`
    color: `, `;
  `])), d.gray.dark1)), P.Dark, p(Kr || (Kr = C([`
    color: `, `;
  `])), d.gray.light1)), Ra = O(O(O(O({}, ie.XSmall, p(Xr || (Xr = C([`
    margin-left: 2px;
  `])))), ie.Small, p(qr || (qr = C([`
    margin-left: 0px;
  `])))), ie.Default, p(Qr || (Qr = C([`
    margin-left: 8px;
  `])))), ie.Large, p(Jr || (Jr = C([`
    margin-left: 8px;
  `])))), _a = O(O({}, P.Light, p(en || (en = C([`
    color: `, `;
  `])), d.gray.base)), P.Dark, p(rn || (rn = C([`
    color: `, `;
  `])), d.gray.dark1)), za = O(O(O(O({}, ie.XSmall, p(nn || (nn = C([`
    height: 22px;
    width: 22px;
  `])))), ie.Small, p(tn || (tn = C([`
    height: 28px;
    width: 28px;
  `])))), ie.Default, p(an || (an = C([`
    height: 28px;
    width: 28px;
  `])))), ie.Large, p(on || (on = C([`
    height: 28px;
    width: 28px;
  `])))), Ma = { Unset: "unset", Loading: "loading" }, Ta = ["placeholder", "className", "darkMode", "size", "disabled", "children", "state", "value", "onChange", "onSubmit", "aria-label", "aria-labelledby"], Na = b.forwardRef(function(e, n) {
  var r = e.placeholder, t = r === void 0 ? "Search" : r, o = e.className, u = e.darkMode, v = e.size, m = v === void 0 ? ie.Default : v, f = e.disabled, h = e.children, y = e.state, w = y === void 0 ? Ma.Unset : y, N = e.value, _ = e.onChange, $ = e.onSubmit, B = e["aria-label"], a = e["aria-labelledby"], s = Ke(e, Ta), c = _e(u), l = c.theme, x = c.darkMode, i = Qe(Ce(!1), 2), S = i[0], L = i[1], j = Qe(Ce(0), 2), E = j[0], A = j[1], H = function() {
    return L(!1);
  }, J = function() {
    return L(!0);
  }, U = Ee(null), V = Ee(null), ee = Ee(null), R = Gn(n, null), q = Ee(null), Y = Zn({ prefix: "result" }), I = Qe(Ce(), 2), W = I[0], Se = I[1], he = Y("".concat(E)), se = !pe(h), Le = bt(N, _), ke = Le.value, ve = Le.handleChange, te = Ue(function(z) {
    R.current && (R.current.value = z, ve(gt(new Event("change", { cancelable: !0, bubbles: !0 }), R.current)));
  }, [ve, R]), ye = Ue(function() {
    var z = 0, F = b.Children.map(h, function K(X) {
      if (Ze(X, "SearchResult")) {
        var ae, le = (z += 1) - 1, k = Ve(X);
        return b.cloneElement(X, Be(Be({}, X.props), {}, { id: "result-".concat(le), key: "result-".concat(le), ref: (ae = X.props.ref) !== null && ae !== void 0 ? ae : Y == null ? void 0 : Y("".concat(le)), highlighted: le === E, onClick: function(de) {
          var Q, fe;
          if ((Q = (fe = X.props).onClick) === null || Q === void 0 || Q.call(fe, de), te(k), de.detail >= 1 && U.current && R.current) {
            var ce, je = new Event("submit", { cancelable: !0, bubbles: !0 });
            (ce = U.current) === null || ce === void 0 || ce.dispatchEvent(je);
          }
        } }));
      }
      if (Ze(X, "SearchResultGroup")) {
        var Z = b.Children.map(X.props.children, K);
        if (Z && Z.length > 0)
          return b.cloneElement(X, Be(Be({}, X.props), {}, { children: Z }));
      }
    });
    return { resultsCount: z, updatedChildren: F };
  }, [h, E, R, Y, te]), Oe = ir(function() {
    return ye();
  }, [ye]), $e = Oe.updatedChildren, ue = Oe.resultsCount, g = function(z) {
    switch (z) {
      case "first":
        A(0);
        break;
      case "last":
        A(ue);
        break;
      case "next":
        var F = !pe(E) && E + 1 < ue ? E + 1 : 0;
        A(F);
        break;
      case "prev":
        var K = !pe(E) && E - 1 >= 0 ? E - 1 : ue - 1;
        A(K);
    }
  };
  return Un(he, ee, 12), Vn(function() {
    H();
  }, [V, ee], S && se), b.createElement(Kn, { darkMode: x }, b.createElement(sa, { state: w, highlight: E, resultDynamicRefs: Y }, b.createElement("form", Ie({ role: "search", ref: U, className: oe(wa, o), onSubmit: function(z) {
    z.preventDefault(), $ == null || $(z), se && (H(), te(""));
  } }, s), b.createElement("div", { ref: V, role: "searchbox", tabIndex: -1, onMouseDown: function(z) {
    f && z.preventDefault();
  }, onClick: function(z) {
    (function(F) {
      f ? (F.preventDefault(), F.stopPropagation()) : J();
    })(z);
  }, onFocus: function(z) {
    var F, K = z.target, X = K === q.current ? q.current : (F = R.current) !== null && F !== void 0 ? F : K;
    X.focus(), Se(X);
  }, onKeyDown: function(z) {
    var F, K, X = (F = ee.current) === null || F === void 0 ? void 0 : F.contains(document.activeElement);
    if ((!((K = V.current) === null || K === void 0) && K.contains(document.activeElement) || X) && !f)
      switch (z.key) {
        case Ne.Enter:
          var ae;
          he == null || (ae = he.current) === null || ae === void 0 || ae.click();
          break;
        case Ne.Escape:
          var le;
          H(), (le = R.current) === null || le === void 0 || le.focus();
          break;
        case Ne.ArrowDown:
          var k;
          se && ((k = R.current) === null || k === void 0 || k.focus(), J(), z.preventDefault(), g("next"));
          break;
        case Ne.ArrowUp:
          var Z;
          se && ((Z = R.current) === null || Z === void 0 || Z.focus(), J(), z.preventDefault(), g("prev"));
          break;
        case Ne.Tab:
          S && H();
          break;
        default:
          se && J();
      }
  }, className: oe(Ca, Ea[m], Sa[l], O(O(O({}, Oa[l], W === R.current), $a[l], f), ka[l], !f)), "aria-label": a ? void 0 : B, "aria-labelledby": a }, b.createElement(na, { className: oe(La[l], Ra[m], O({}, _a[l], f)), role: "presentation" }), b.createElement("input", { type: "search", className: oe(ja, Pa[l]), value: ke, onChange: function(z) {
    ve == null || ve(z);
  }, placeholder: t, ref: R, readOnly: f, "aria-disabled": f }), ke && b.createElement(Lt, { ref: q, type: "button", "aria-label": "Clear search", onClick: function(z) {
    var F;
    z.stopPropagation(), te(""), R == null || (F = R.current) === null || F === void 0 || F.focus();
  }, className: za[m], tabIndex: f ? -1 : 0, disabled: f }, b.createElement(aa, null))), se && b.createElement(lr, { open: S, refEl: V, ref: ee }, $e))));
});
Na.displayName = "SearchInput";
var ln, cn, sn, Aa = ["as", "children", "description", "disabled", "className", "darkMode"], Da = Xn(function(e, n) {
  var r, t = e.as, o = t === void 0 ? "li" : t, u = e.children, v = e.description, m = e.disabled, f = e.className;
  e.darkMode;
  var h = Ke(e, Aa), y = Ve(u), w = (r = h["aria-label"]) !== null && r !== void 0 ? r : h["aria-labelledby"] ? "" : y;
  return b.createElement(He, Ie({}, h, { as: o, ref: n, className: f, disabled: m, "aria-labelledby": h["aria-labelledby"], "aria-label": w }), b.createElement(Qn, { description: v, preserveIconSpace: !1 }, b.createElement("strong", null, u)));
}, "SearchResult");
Da.displayName = "SearchResult";
p(ln || (ln = C([`
  padding-top: 12px;
  padding-bottom: 0;
`])));
O(O({}, P.Light, p(cn || (cn = C([`
    color: `, `;
  `])), d.gray.dark1)), P.Dark, p(sn || (sn = C([`
    color: `, `;
  `])), d.gray.base));
function un(e, n) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(e);
    n && (t = t.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), r.push.apply(r, t);
  }
  return r;
}
function We(e) {
  for (var n = 1; n < arguments.length; n++) {
    var r = arguments[n] != null ? arguments[n] : {};
    n % 2 ? un(Object(r), !0).forEach(function(t) {
      G(e, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : un(Object(r)).forEach(function(t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return e;
}
function Ia(e) {
  var n = function(r, t) {
    if (typeof r != "object" || !r)
      return r;
    var o = r[Symbol.toPrimitive];
    if (o !== void 0) {
      var u = o.call(r, t);
      if (typeof u != "object")
        return u;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return String(r);
  }(e, "string");
  return typeof n == "symbol" ? n : n + "";
}
function G(e, n, r) {
  return (n = Ia(n)) in e ? Object.defineProperty(e, n, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[n] = r, e;
}
function me() {
  return me = Object.assign ? Object.assign.bind() : function(e) {
    for (var n = 1; n < arguments.length; n++) {
      var r = arguments[n];
      for (var t in r)
        Object.prototype.hasOwnProperty.call(r, t) && (e[t] = r[t]);
    }
    return e;
  }, me.apply(this, arguments);
}
function cr(e, n) {
  if (e == null)
    return {};
  var r, t, o = function(v, m) {
    if (v == null)
      return {};
    var f, h, y = {}, w = Object.keys(v);
    for (h = 0; h < w.length; h++)
      f = w[h], m.indexOf(f) >= 0 || (y[f] = v[f]);
    return y;
  }(e, n);
  if (Object.getOwnPropertySymbols) {
    var u = Object.getOwnPropertySymbols(e);
    for (t = 0; t < u.length; t++)
      r = u[t], n.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (o[r] = e[r]);
  }
  return o;
}
function D(e, n) {
  return n || (n = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(n) } }));
}
function Ae(e, n) {
  return function(r) {
    if (Array.isArray(r))
      return r;
  }(e) || function(r, t) {
    var o = r == null ? null : typeof Symbol < "u" && r[Symbol.iterator] || r["@@iterator"];
    if (o != null) {
      var u, v, m, f, h = [], y = !0, w = !1;
      try {
        if (m = (o = o.call(r)).next, t !== 0)
          for (; !(y = (u = m.call(o)).done) && (h.push(u.value), h.length !== t); y = !0)
            ;
      } catch (N) {
        w = !0, v = N;
      } finally {
        try {
          if (!y && o.return != null && (f = o.return(), Object(f) !== f))
            return;
        } finally {
          if (w)
            throw v;
        }
      }
      return h;
    }
  }(e, n) || function(r, t) {
    if (r) {
      if (typeof r == "string")
        return dn(r, t);
      var o = Object.prototype.toString.call(r).slice(8, -1);
      if (o === "Object" && r.constructor && (o = r.constructor.name), o === "Map" || o === "Set")
        return Array.from(r);
      if (o === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(o))
        return dn(r, t);
    }
  }(e, n) || function() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }();
}
function dn(e, n) {
  n > e.length && (n = e.length);
  for (var r = 0, t = new Array(n); r < n; r++)
    t[r] = e[r];
  return t;
}
var fn, pn, bn, gn, mn, hn, vn, yn, xn, wn, Cn, En, Sn, kn, On, $n, jn, Pn, Ln, Rn, _n, zn, Mn, Fa = p(fn || (fn = D([`
  width: 100%;
  position: relative;
`]))), Ha = p(pn || (pn = D([`
  width: 100%;
  display: grid;
  grid-template-columns: auto 1fr auto;
  position: relative;
  border-radius: 8px;
  border: 1px solid `, `;
  z-index: 2;

  &:disabled {
    cursor: not-allowed;

    &:hover,
    &:active {
      box-shadow: none;
    }
  }
`])), d.gray.base), Ba = p(bn || (bn = D([`
  border-color: transparent;
`]))), Wa = G(G({}, P.Dark, p(gn || (gn = D([`
    background-color: `, `;
    color: `, `;
  `])), d.black, d.white)), P.Light, p(mn || (mn = D([`
    background-color: `, `;
    color: black;
  `])), d.white)), Ya = p(hn || (hn = D([`
  display: flex;
  gap: `, `px;
  align-items: center;
  align-self: top;
  height: 36px; // hard set to height of textarea
  padding: `, "px 0px ", "px ", `px;
  background-color: inherit;
  border-top-left-radius: inherit;
  border-bottom-left-radius: inherit;
`])), ne[2], ne[1], ne[1], ne[2]), Ga = p(vn || (vn = D([`
  display: flex;
  align-items: flex-end;
  gap: `, `px;
  padding: `, `px;
  background-color: inherit;
  border-top-right-radius: inherit;
  border-bottom-right-radius: inherit;
`])), ne[2], ne[1]), Za = p(yn || (yn = D([`
  flex: 1;
  font-size: `, `px;
  font-family: `, `;
  font-weight: `, `;
  height: 36px;
  padding: `, `px;
  outline: none;
  border: none;
  transition: `, `ms ease-in-out;
  transition-property: border-color, box-shadow;
  overflow-y: scroll;
  resize: none; // to remove bottom right diagonal lines
  box-sizing: content-box;
  line-height: `, `px;
  max-height: 160px;
  background-color: inherit;
  color: inherit;
  margin: 0; // firefox creates margins on textareas - remove it for consistent sizing

  &:disabled {
    &::placeholder {
      color: inherit;
    }

    &:disabled:-webkit-autofill {
      &,
      &:hover,
      &:focus {
        appearance: none;
        -webkit-text-fill-color: `, `;
      }
    }
  }
`])), mt.Body1, Yn.default, Ge.regular, ne[2], Fe.default, ge.body1.lineHeight, d.gray.base), er = G(G({}, P.Dark, p(xn || (xn = D([`
    color: `, `;
    background-color: `, `;
    border-color: `, `;
  `])), d.gray.dark1, d.gray.dark3, d.gray.dark2)), P.Light, p(wn || (wn = D([`
    color: `, `;
    background-color: `, `;
    border-color: `, `;
  `])), d.gray.base, d.gray.light2, d.gray.light1)), Ua = G(G({}, P.Dark, p(Cn || (Cn = D([`
    background-color: `, `;
    color: `, `;
    &:disabled {
      `, `
    }
  `])), d.black, d.white, er[P.Dark])), P.Light, p(En || (En = D([`
    background-color: `, `;
    color: black;
    &:disabled {
      `, `
    }
    &::placeholder {
      color: `, `;
    }
  `])), d.white, er[P.Light], d.gray.base)), Va = p(Sn || (Sn = D([`
  border-radius: 8px;
`]))), Ka = p(kn || (kn = D([`
  box-shadow: `, `;
  border-color: transparent;
  transition: `, `ms ease-in-out;
  transition-property: border-color, box-shadow;
`])), De.light.input, Fe.default), Xa = p(On || (On = D([`
  &:before,
  &:after {
    content: '';
    position: absolute;
    top: -`, `px;
    left: -`, `px;
    width: calc(100% + `, `px);
    height: calc(100% + `, `px);
    border-radius: 12px;
    background-color: `, `;
    background-size: 400% 400%;
    background-position: 800% 800%; // set final state of animation
  }

  &:after {
    animation: 4s animateBg linear;
  }

  &:before {
    filter: blur(4px) opacity(0.6);
    animation: 4s animateBg, animateShadow linear infinite;
    opacity: 0;
  }

  @keyframes animateBg {
    0% {
      background-position: 400% 400%;
      background-image: linear-gradient(
        20deg,
        `, ` 0%,
        `, ` 30%,
        #00ede0 45%,
        #00ebc1 75%,
        #0498ec
      );
    }
    100% {
      background-position: 0% 0%;
      background-image: linear-gradient(
        20deg,
        `, ` 0%,
        `, ` 30%,
        #00ede0 45%,
        #00ebc1 75%,
        #0498ec
      );
    }
  }

  @keyframes animateShadow {
    0% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }
`])), 4, 4, 8, 8, d.blue.light1, d.blue.light1, d.blue.light1, d.blue.light1, d.blue.light1), qa = p($n || ($n = D([`
  &:hover {
    box-shadow: none;
  }
`]))), Qa = p(jn || (jn = D([`
  padding: `, "px ", `px;
  border-radius: `, `px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: default;
  user-select: none;
`])), ne[100], ne[400], ht[400]), Ja = G(G({}, P.Dark, p(Pn || (Pn = D([`
    background-color: `, `;
    border: 1px solid `, `;
    color: `, `;
  `])), d.gray.dark4, d.gray.dark2, d.gray.light2)), P.Light, p(Ln || (Ln = D([`
    background-color: `, `;
    border: 1px solid `, `;
    color: `, `;
  `])), d.gray.light2, d.gray.light2, d.green.dark2)), eo = or(Rn || (Rn = D([`
  from {
    opacity: 0;
    display: none;
  }
  to {
    opacity: 1;
    display: flex;
  }
`]))), ro = p(_n || (_n = D([`
  opacity: 1;
  animation: `, " ", `ms forwards;
`])), eo, Fe.default), no = or(zn || (zn = D([`
  from {
    display: flex;
    opacity: 1;
  }
  to {
    display: none;
    opacity: 0;
  }
`]))), to = p(Mn || (Mn = D([`
  opacity: 0;
  animation: `, " ", `ms forwards;
`])), no, Fe.default), Tn = function(e, n) {
  return e === P.Dark ? n ? d.gray.dark1 : d.gray.light1 : n ? d.gray.base : d.gray.dark1;
}, ao = Jn("Return", function(e) {
  return b.createElement("svg", me({ width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, e), b.createElement("g", { id: "Return" }, b.createElement("path", { id: "Union", d: "M5 2C4.44772 2 4 2.44772 4 3C4 3.55228 4.44772 4 5 4H10C11.3807 4 12.5 5.11929 12.5 6.5C12.5 7.88071 11.3807 9 10 9H5.20328L6.65079 7.75927C7.07012 7.39985 7.11868 6.76855 6.75926 6.34923C6.39983 5.9299 5.76853 5.88134 5.34921 6.24076L1.84921 9.24076C1.62756 9.43074 1.5 9.70809 1.5 10C1.5 10.2919 1.62756 10.5693 1.84921 10.7593L5.34921 13.7593C5.76853 14.1187 6.39983 14.0701 6.75926 13.6508C7.11868 13.2315 7.07012 12.6002 6.65079 12.2408L5.20324 11H10C12.4853 11 14.5 8.98528 14.5 6.5C14.5 4.01472 12.4853 2 10 2H5Z", fill: "currentColor" })));
}), oo = Jn("Sparkle", function(e) {
  return b.createElement("svg", me({ width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, e), b.createElement("path", { d: "M6.27334 2.89343L5.27501 5.88842C5.1749 6.18877 4.93922 6.42445 4.63887 6.52456L1.64388 7.52289C1.18537 7.67573 1.18537 8.32427 1.64388 8.47711L4.63887 9.47544C4.93922 9.57555 5.1749 9.81123 5.27501 10.1116L6.27334 13.1066C6.42618 13.5651 7.07472 13.5651 7.22756 13.1066L8.22589 10.1116C8.326 9.81123 8.56168 9.57555 8.86203 9.47544L11.857 8.47711C12.3155 8.32427 12.3155 7.67573 11.857 7.52289L8.86203 6.52456C8.56168 6.42445 8.326 6.18877 8.22589 5.88842L7.22756 2.89343C7.07472 2.43492 6.42618 2.43492 6.27334 2.89343Z", fill: "currentColor" }), b.createElement("path", { d: "M12.5469 1.17194L12.3158 1.8651C12.2157 2.16545 11.98 2.40113 11.6797 2.50125L10.9865 2.7323C10.7573 2.80872 10.7573 3.13299 10.9865 3.20941L11.6797 3.44046C11.98 3.54058 12.2157 3.77626 12.3158 4.0766L12.5469 4.76977C12.6233 4.99902 12.9476 4.99902 13.024 4.76977L13.255 4.0766C13.3552 3.77626 13.5908 3.54058 13.8912 3.44046L14.5843 3.20941C14.8136 3.13299 14.8136 2.80872 14.5843 2.7323L13.8912 2.50125C13.5908 2.40113 13.3552 2.16545 13.255 1.8651L13.024 1.17194C12.9476 0.942687 12.6233 0.942687 12.5469 1.17194Z", fill: "currentColor" }), b.createElement("path", { d: "M12.5469 11.2302L12.3158 11.9234C12.2157 12.2237 11.98 12.4594 11.6797 12.5595L10.9865 12.7906C10.7573 12.867 10.7573 13.1913 10.9865 13.2677L11.6797 13.4988C11.98 13.5989 12.2157 13.8346 12.3158 14.1349L12.5469 14.8281C12.6233 15.0573 12.9476 15.0573 13.024 14.8281L13.255 14.1349C13.3552 13.8346 13.5908 13.5989 13.8912 13.4988L14.5843 13.2677C14.8136 13.1913 14.8136 12.867 14.5843 12.7906L13.8912 12.5595C13.5908 12.4594 13.3552 12.2237 13.255 11.9234L13.024 11.2302C12.9476 11.001 12.6233 11.001 12.5469 11.2302Z", fill: "currentColor" }));
}), io = ["className", "textareaProps", "onMessageSend", "onSubmit", "shouldRenderHotkeyIndicator", "shouldRenderGradient", "badgeText", "darkMode", "disabled", "disableSend", "children", "dropdownFooterSlot", "dropdownProps"], lt = qn(function(e, n) {
  var r, t, o = e.className, u = e.textareaProps, v = e.onMessageSend, m = e.onSubmit, f = e.shouldRenderHotkeyIndicator, h = f !== void 0 && f, y = e.shouldRenderGradient, w = y === void 0 || y, N = e.badgeText, _ = e.darkMode, $ = e.disabled, B = e.disableSend, a = e.children, s = e.dropdownFooterSlot, c = e.dropdownProps, l = cr(e, io), x = Gn(n, null), i = Ee(null), S = Ee(null), L = Ee(null), j = Zn({ prefix: "suggested-prompt" }), E = Ae(Ce(!1), 2), A = E[0], H = E[1], J = Ae(Ce((r = u == null || (t = u.value) === null || t === void 0 ? void 0 : t.toString()) !== null && r !== void 0 ? r : ""), 2), U = J[0], V = J[1], ee = Ae(Ce(!1), 2), R = ee[0], q = ee[1], Y = Ae(Ce(void 0), 2), I = Y[0], W = Y[1], Se = j("".concat(I)), he = Ae(Ce(!1), 2), se = he[0], Le = he[1], ke = _e(_), ve = ke.darkMode, te = ke.theme, ye = $t().containerWidth, Oe = w && A && !$, $e = function() {
    return B || $ || U === "";
  }, ue = !pe(a), g = Ue(function() {
    var k = 0, Z = It(a).map(function de(Q) {
      if (Ze(Q, "SuggestedPrompt")) {
        var fe, ce = (k += 1) - 1, je = Ve(Q);
        return b.cloneElement(Q, We(We({}, Q.props), {}, { id: "suggested-prompt-".concat(ce), key: "suggested-prompt-".concat(ce), ref: (fe = Q.props.ref) !== null && fe !== void 0 ? fe : j == null ? void 0 : j("".concat(ce)), highlighted: ce === I, onClick: function(Me) {
          var Pe, Re;
          (Pe = (Re = Q.props).onClick) === null || Pe === void 0 || Pe.call(Re, Me), V(je);
          var Te = setTimeout(function() {
            var be;
            x == null || (be = x.current) === null || be === void 0 || be.requestSubmit(), clearTimeout(Te);
          });
          ae();
        } }));
      }
      if (Ze(Q, "SuggestedPrompts")) {
        var ze = b.Children.map(Q.props.children, de);
        if (ze && ze.length > 0)
          return b.cloneElement(Q, We(We({}, Q.props), {}, { children: ze }));
      }
    });
    return { resultsCount: k, updatedChildren: Z };
  }, [a, I, L, j, V]), z = ir(function() {
    return g();
  }, [g]), F = z.updatedChildren, K = z.resultsCount;
  Ot(function() {
    var k = ye !== void 0 && ye >= yt.Mobile;
    k !== se && Le(k);
  }, [ye]);
  var X = function(k) {
    switch (k) {
      case "first":
        W(0);
        break;
      case "last":
        W(K);
        break;
      case "next":
        var Z = !pe(I) && I + 1 < K ? I + 1 : 0;
        W(Z);
        break;
      case "prev":
        var de = !pe(I) && I - 1 >= 0 ? I - 1 : K - 1;
        W(de);
    }
  }, ae = function() {
    q(!1), W(void 0);
  }, le = function() {
    return q(!0);
  };
  return Un(Se, S, 12), Vn(function() {
    ae();
  }, [i, S], R && ue), vt("keydown", function(k) {
    !k.repeat && k.key === "/" && L.current && (k.preventDefault(), k.stopPropagation(), L.current.focus());
  }, { enabled: h && !A }), b.createElement(Kn, { darkMode: ve }, b.createElement("form", me({ className: oe(Fa, o), onSubmit: function(k) {
    k.preventDefault(), $e() || (v && U && (v(U, k), V("")), m == null || m(k));
  }, ref: x }, l), b.createElement("div", { className: oe(Va, G(G({}, Xa, Oe), Ka, !Oe && A && !$)), ref: i }, b.createElement("div", { className: oe(Ha, Wa[te], G(G({}, er[te], $), Ba, A)) }, b.createElement("div", { className: Ya }, b.createElement(oo, { fill: Tn(te, $) }), N && b.createElement(jt, { variant: "blue" }, N)), b.createElement(ea, me({ "aria-keyshortcuts": "/", placeholder: "Type your message here", value: U, disabled: $ }, u ?? {}, { className: oe(Za, Ua[te], u == null ? void 0 : u.className), onKeyDown: function(k) {
    var Z, de, Q = (Z = S.current) === null || Z === void 0 ? void 0 : Z.contains(document.activeElement);
    if (!((de = i.current) === null || de === void 0) && de.contains(document.activeElement) || Q)
      switch (k.key) {
        case "Enter":
          var fe, ce;
          if (k.preventDefault(), pe(I))
            if (k.ctrlKey || k.shiftKey) {
              if (k.ctrlKey || k.shiftKey) {
                var je;
                (function(be, ct) {
                  var st = be.value;
                  be.value = ct;
                  var sr = be == null ? void 0 : be._valueTracker;
                  sr && sr.setValue(st), be.dispatchEvent(new Event("change", { bubbles: !0 }));
                })(L == null ? void 0 : L.current, U + `
`), V(U + `
`);
                var ze = new Event("change", { bubbles: !0 });
                (je = L.current) === null || je === void 0 || je.dispatchEvent(ze);
              }
            } else
              (fe = x.current) === null || fe === void 0 || fe.requestSubmit();
          else
            Se == null || (ce = Se.current) === null || ce === void 0 || ce.click();
          break;
        case "Escape":
          var Me;
          ae(), (Me = L.current) === null || Me === void 0 || Me.focus();
          break;
        case "ArrowDown":
          var Pe;
          ue && ((Pe = L.current) === null || Pe === void 0 || Pe.focus(), le(), k.preventDefault(), pe(I) ? W(0) : X("next"));
          break;
        case "ArrowUp":
          var Re;
          ue && ((Re = L.current) === null || Re === void 0 || Re.focus(), le(), k.preventDefault(), pe(I) ? W(K - 1) : X("prev"));
          break;
        case "Tab":
          R && ae();
          break;
        default:
          var Te;
          u != null && u.onKeyDown && (u == null || (Te = u.onKeyDown) === null || Te === void 0 || Te.call(u, k)), ae();
      }
  }, onChange: function(k) {
    var Z;
    V(k.target.value), u != null && u.onChange && (u == null || (Z = u.onChange) === null || Z === void 0 || Z.call(u, k));
  }, onFocus: function(k) {
    H(!0), le();
  }, onBlur: function(k) {
    H(!1);
  }, ref: L })), b.createElement("div", { className: Ga }, h && !$ && b.createElement("div", { "data-testid": "lg-chat-hotkey-indicator", className: oe(Qa, Ja[te], G(G({}, to, A), ro, !A)) }, "/"), b.createElement(Pt, { size: "small", rightGlyph: b.createElement(ao, { fill: Tn(te, $) }), type: "submit", disabled: $e(), className: oe(G({}, qa, $e())) }, se && "Enter")))), ue && b.createElement(lr, me({ open: R, refEl: i, ref: S, footerSlot: s }, c), F)));
});
lt.displayName = "InputBar";
var Nn, An, Dn, In, Fn, lo = ["as", "children", "disabled", "className", "darkMode"], co = Xn(function(e, n) {
  var r, t = e.as, o = t === void 0 ? "li" : t, u = e.children, v = e.disabled, m = e.className;
  e.darkMode;
  var f = cr(e, lo), h = Ve(u), y = (r = f["aria-label"]) !== null && r !== void 0 ? r : f["aria-labelledby"] ? "" : h;
  return b.createElement(He, me({}, f, { as: o, ref: n, className: m, disabled: v, "aria-labelledby": f["aria-labelledby"], "aria-label": y }), b.createElement(Qn, { preserveIconSpace: !1 }, u));
}, "SuggestedPrompt");
co.displayName = "SuggestedPrompt";
var so = G(G({}, P.Light, p(Nn || (Nn = D([`
    & + & {
      border-top: 1px solid `, `;
    }
  `])), d.gray.light2)), P.Dark, p(An || (An = D([`
    & + & {
      border-top: 1px solid `, `;
    }
  `])), d.gray.dark2)), uo = p(Dn || (Dn = D([`
  padding-bottom: 0;
`]))), fo = G(G({}, P.Light, p(In || (In = D([`
    color: `, `;
  `])), d.gray.dark1)), P.Dark, p(Fn || (Fn = D([`
    color: `, `;
  `])), d.gray.base)), po = ["children", "label"], bo = function(e) {
  var n = e.children, r = e.label, t = cr(e, po), o = xt(n, ["SuggestedPrompt", "SuggestedPrompts"]), u = _e().theme;
  return b.createElement("div", { className: so[u] }, b.createElement(He, me({ "aria-label": r, isInteractive: !1, className: uo }, t), b.createElement(wt, { className: fo[u] }, r)), o);
};
bo.displayName = "SuggestedPrompts";
const rr = {
  chatbot_input_error_border: Xe`
    > div {
      > div {
        border-color: ${d.red.base} !important;
        border-width: 2px !important;
      }
    }
  `,
  suggested_prompts_menu: Xe`
    [data-testid="lg-search-input-popover"] {
      z-index: 1;
    }
  `,
  character_count: ({
    darkMode: e,
    isError: n
  }) => Xe`
    white-space: nowrap;
    color: ${n ? d.red.base : e ? d.gray.light2 : d.gray.dark2};
  `
}, jo = qn(
  function({ children: n, hasError: r, ...t }, o) {
    return /* @__PURE__ */ Bn.jsx(
      lt,
      {
        ref: o,
        className: Wn(
          rr.suggested_prompts_menu,
          r ?? !1 ? rr.chatbot_input_error_border : void 0
        ),
        shouldRenderGradient: !r,
        ...t,
        children: n
      }
    );
  }
);
function Po({
  current: e,
  max: n,
  darkMode: r,
  className: t
}) {
  return /* @__PURE__ */ Bn.jsx(
    Ct,
    {
      className: Wn(
        rr.character_count({
          darkMode: r,
          isError: e > n
        }),
        t
      ),
      children: `${e} / ${n}`
    }
  );
}
function Lo() {
  const { awaitingReply: e, chatbotName: n } = Mt();
  return e ? n ? `${n} is answering...` : "Answering..." : n ? `Ask ${n} a Question` : "Ask a Question";
}
export {
  Po as C,
  jo as I,
  Lo as M,
  co as X,
  bo as t
};
